import React from 'react';
import { Link } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';
import { internalHref } from '../utils/internalHref';

interface CalculatorCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  link: string;
  featured?: boolean;
}

const CalculatorCard: React.FC<CalculatorCardProps> = ({ title, description, icon: Icon, link, featured = false }) => {
  return (
    <Link to={internalHref(link)} className="block">
      <div className={`${featured ? 'bg-blue-50 border-2 border-blue-200' : 'bg-white'} rounded-xl shadow-sm p-6 card-hover`}>
        {featured && (
          <div className="inline-block bg-blue-600 text-white text-xs font-semibold px-2 py-1 rounded-full mb-4">
            Featured
          </div>
        )}
        <div className="flex items-center mb-4">
          <div className={`${featured ? 'bg-blue-100' : 'bg-blue-50'} p-2 rounded-lg`}>
            <Icon className={`h-6 w-6 ${featured ? 'text-blue-700' : 'text-blue-600'}`} />
          </div>
        </div>
        <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </Link>
  );
};

export default CalculatorCard;